module.exports = __webpack_public_path__ + "img/34_newYouth_zyx.7c1da915.png";